import { render, staticRenderFns } from "./qyxxbgDia.vue?vue&type=template&id=bcb8b3e6&scoped=true&"
import script from "./qyxxbgDia.vue?vue&type=script&lang=js&"
export * from "./qyxxbgDia.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgDia.vue?vue&type=style&index=0&id=bcb8b3e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb8b3e6",
  null
  
)

export default component.exports